"use client";
import { i as r, a as u } from "./detectBrowser-CpuomNQW.mjs";
function n(i) {
  i.preventDefault(), i.stopPropagation();
}
function a(i) {
  return "nativeEvent" in i;
}
function p(i) {
  return i.mozInputSource === 0 && i.isTrusted ? !0 : r && i.pointerType ? i.type === "click" && i.buttons === 1 : i.detail === 0 && !i.pointerType;
}
function e(i) {
  return u ? !1 : !r && i.width === 0 && i.height === 0 || r && i.width === 1 && i.height === 1 && i.pressure === 0 && i.detail === 0 && i.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  i.width < 1 && i.height < 1 && i.pressure === 0 && i.detail === 0 && i.pointerType === "touch";
}
function c(i, s) {
  const t = ["mouse", "pen"];
  return s || t.push("", void 0), t.includes(i);
}
export {
  p as a,
  e as b,
  a as c,
  c as i,
  n as s
};
